module.exports = __webpack_public_path__ + "img/footer4.b7e5cb9b.svg";